import { ref } from 'vue'

export const mostRecentOrderClass = ref('')
